// extracted by mini-css-extract-plugin
export default {"container":"HighCV_container__t3pcl","title":"HighCV_title__RK1se"};